import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Service.css';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils';

const Service = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [services, setServices] = useState([]);
  
  const baseURL = window.APP_CONFIG?.API_URL || "https://backendweb.properteck.lk";

  useEffect(() => {
    // Fetch services data when component mounts
    fetchServices();
  }, []);

  const fetchServices = async () => {
    setIsLoading(true);
    setApiError(null);
    try {
      // Fetch services information with timeout
      const response = await axios.get(`${baseURL}/api/services/getservices`, {
        timeout: 5000 // 5 second timeout
      });
      
      if (response.data && response.data.services) {
        setServices(response.data.services);
      } else {
        // Handle case when expected data structure is not received
        console.error('Unexpected API response structure:', response.data);
        setApiError({
          message: 'Received invalid data format from server',
          details: 'The API response does not contain the expected services data structure'
        });
      }
    } catch (error) {
      console.error('Error fetching services:', error);
      setApiError({
        message: 'Failed to load services information',
        details: error.message
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  // Using utility function from imageUtils

  // Get default icon based on category
  const getCategoryIcon = (category) => {
    const categoryIcons = {
      'hardware': 'fa-microchip',
      'software': 'fa-code',
      'network': 'fa-network-wired',
      'support': 'fa-headset',
      'other': 'fa-tools'
    };
    
    return categoryIcons[category] || 'fa-cog';
  };

  // Retry API connection
  const handleRetryConnection = () => {
    fetchServices();
  };

  return (
    <div className="services-page-container">
      <div className="services-page-wrapper">
        {/* Services Section Header */}
        <h1 className="services-page-title">OUR SERVICES</h1>
        
        {/* Services Description */}
        <div className="services-intro">
          <p className="services-intro-text">
            At <strong>PROPERTECK</strong>, we offer a comprehensive range of computer and IT services 
            designed to meet all your technology needs. From custom builds to repairs, 
            our expert team is ready to deliver top-notch solutions.
          </p>
        </div>
        
        {/* Services List */}
        {isLoading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading services...</p>
          </div>
        ) : apiError ? (
          <div className="api-error">
            <h3>Connection Issue</h3>
            <p>{apiError.message}</p>
            <p className="error-details">{apiError.details}</p>
            <button className="retry-btn" onClick={handleRetryConnection}>
              Retry Connection
            </button>
          </div>
        ) : (
          <div className="services-container">
            <div className="services-grid">
              {services.length > 0 ? (
                services.map(service => (
                  <div key={service._id} className="service-card">
                    <div className={`icon-wrapper ${service.category}-icon`}>
                      {service.icon && getImageUrl(service.icon) ? (
                        <img 
                          src={getImageUrl(service.icon)} 
                          alt={service.name} 
                          className="icon"
                        />
                      ) : (
                        <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="https://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                        </svg>
                      )}
                    </div>
                    <h3>{service.name}</h3>
                    <p>{service.description}</p>
                  </div>
                ))
              ) : (
                <div className="no-services">
                  <p>No services available at the moment. Please check back later.</p>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Call to Action */}
        <div className="services-cta">
          <h2>Need a custom solution?</h2>
          <p>Contact our team of experts for personalized assistance with your specific technology needs.</p>
          <button className="services-contact-btn" onClick={handleContactClick}>Contact Us</button>
        </div>
      </div>
    </div>
  );
};

export default Service;